// extracted by mini-css-extract-plugin
module.exports = {"container":"uw809CJ2","logo":"_15cj2rEt p1","icon":"_17oTuriG","text":"_2ch7lMsU m1","button":"-No-8LVF m1"};